import React, { useState } from "react";
import { NativeSelectProps } from "@material-ui/core/NativeSelect";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import { StyledGrid } from "components/simple";
import { StyledSelect, StyledInputLabel } from "./styled";
import { FormControl } from "@material-ui/core";

interface CustomProps {
  callback: React.Dispatch<string | number>;
  inputLabel?: String;
  defaultText?: string;
  options: Record<string, string | number>[];
  selectedValue?: number;
}

type DropdownProps = CustomProps & NativeSelectProps;

const DropdownSelect: React.FC<DropdownProps> = ({
  callback,
  defaultText,
  options,
  selectedValue,
  inputLabel,
  ...otherProps
}: DropdownProps) => {
  const [value, setValue] = useState("");

  const handleChange = (event: React.ChangeEvent<unknown>): void => {
    const value = (event.target as HTMLInputElement).value;
    setValue(value);
    callback(value);
  };

  return (
    <StyledGrid container alignItems={"center"}>
      <FormControl fullWidth>
        {inputLabel && (
          <StyledInputLabel htmlFor={`${inputLabel}-label`}>{inputLabel}</StyledInputLabel>
        )}
        <StyledSelect
          IconComponent={ArrowDropDownIcon}
          value={value}
          variant="outlined"
          onChange={handleChange}
          inputProps={{ id: `${inputLabel}-dropdown` }}
          hasInputLabel={inputLabel && inputLabel?.length > 1}
          {...otherProps}
        >
          <option value={""} disabled>
            {defaultText}
          </option>
          {options?.map((option: Record<string, string | number>) => {
            const keyString = Object.keys(option)[0];
            const valueNumber = option[keyString];
            return (
              <option key={valueNumber} value={valueNumber}>
                {keyString}
              </option>
            );
          })}
        </StyledSelect>
      </FormControl>
    </StyledGrid>
  );
};

export default DropdownSelect;
